import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-pale px-4 py-6 md:px-12 md:py-8" data-id="element-88" data-mp="4uqfz2u0sewh">
      <div className="flex gap-3 rounded-md border border-gold bg-white p-3.5 md:p-5" data-id="element-89" data-mp="4x34xzy73pj1">
        <ShieldCheckIcon className="h-9 w-9 shrink-0 text-gold" strokeWidth={1.75} aria-hidden data-id="element-90" data-mp="9wfq8g9f4oji" />
        <div data-id="element-91" data-mp="euqwyi4f2ixi">
          <h2 className="font-heading text-[17px] font-extrabold uppercase leading-[1.15] tracking-[-0.2px] text-navy md:text-[21px]" data-id="element-92" data-mp="er36jru9qcn0">
            Your purchase is protected.
          </h2>
          <p className="mt-0.5 font-heading text-[12px] font-extrabold uppercase text-brand md:text-[13px]" data-id="element-93" data-mp="ns19e6sz0e40">
            7-day money-back guarantee
          </p>
          <div className="mt-1.5 space-y-1 text-[14px] leading-[1.4] text-ink md:text-[15px]" data-id="element-94" data-mp="xiw1hrswe7xd">
            <p data-id="element-95" data-mp="12k35dfrx6myr">
              Explore the six volumes and five bonuses for seven days. If the materials aren't the right fit, request a
              refund within seven days of purchase, subject to the store's published refund policy.
            </p>
          </div>
          <p className="mt-2 font-heading text-[12px] font-extrabold uppercase leading-tight text-goldDark md:text-[13px]" data-id="element-96" data-mp="20t3v6tqiv0ya">
            Your purchase includes digital access and a 7-day money-back guarantee.
          </p>
        </div>
      </div>
    </section>;
}